import AgeFilterComponent, { OtherAgeElementType } from "./components/ageFilterComponent";
import GenderFilterComponent from "./components/genderFilterComponent";
import {useSelector,useDispatch} from 'react-redux'
import './filterWrapperStyle.css'
import { getEvdaDepartmentsAgeFilterState, getEvdaDepartmentsDateFilterState, getEvdaDepartmentsGenderFilterState } from "../../redux/selectors/filterSelector";
import { SelectedAge } from "../../models/SelectedAge";
import { FilterAction } from "../../redux/states/filterState";
import { SelectedGender } from "../../models/SelectedGender";
import DateFilterComponent from "./components/dateFilterComponent";
import DepartmentsSelectionComponent from "./components/departmentsSelectionComponent";
import { DropDownItem } from "../../models/DropDownItem";
import {MapPoint} from "../../service/MapPoint";
export type Props = {
    differentAges:DropDownItem[]
    maxDate:number,
    data: MapPoint[]
}
const EvdaDepartmentFilterWrapper:React.FC<Props>=({differentAges,maxDate, data})=>{
        const dispatch = useDispatch()
        const agerFilter = useSelector(getEvdaDepartmentsAgeFilterState)
        const genderFilter = useSelector(getEvdaDepartmentsGenderFilterState)
        const dateFilter = useSelector(getEvdaDepartmentsDateFilterState)
        const onsetAgeSelectionHandler=(selection:SelectedAge)=>{
            dispatch(FilterAction.SetEvdaDepartmentsAgeSelection(selection))
        } 
        const onSetGenderSelection=(gender:SelectedGender) =>{
            dispatch(FilterAction.SetEvdaDepartmentsGenderInSelection(gender))
        }
        const onSetYearSelection =(year: number)=>{
            dispatch(FilterAction.setEvdaDepartmentsSelectedYear(year))
        }

        const onSetDepartmentCustomAge=(item:DropDownItem)=>{
           dispatch(FilterAction.setEvdaDepartmentsCustomSelectedAge(item))
        }
    return(<>
        <AgeFilterComponent 
            selectedAge={agerFilter.seletedAge} 
            customAgeElement={OtherAgeElementType.dropDownList} 
            customSelectedAge={agerFilter.customSelectedAge}
            OtherAgesList={differentAges}
            onSetDepartmentCustomAge={onSetDepartmentCustomAge}
            onSetSelection={onsetAgeSelectionHandler}/>
        <GenderFilterComponent 
            selectedGender={genderFilter.selectedGender} 
            setSelectectionHandler={onSetGenderSelection}/>
        <DepartmentsSelectionComponent data={data} ></DepartmentsSelectionComponent>
        <DateFilterComponent minValue={1975} maxValue={maxDate} selectedYear={dateFilter.selectedyear} setSelectedYearHandler={onSetYearSelection}/>
        </>)
}

export default EvdaDepartmentFilterWrapper;